import { Injectable } from '@angular/core';
import { DataCoreService } from '@dabnet-kamu/libs/ui';
import { GenKisiService } from '../ctl-gen-kisi.service';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
@Injectable()
export class GenKisiAramaService {
  constructor(
    private dataCoreService: DataCoreService,
    private genKisiService: GenKisiService
  ) {}

  getData(control: any, filterArray: any[], customSearch?: string) {
    let queryString = '?';
    if (customSearch?.length > 0) {
      queryString = queryString + 'search=' + customSearch;
    }
    if (this.genKisiService.exBirlesenEh) {
      if (queryString.length === 1)
        queryString = queryString + 'ExBirlesenEh=E';
      else if (queryString.length > 1)
        queryString = queryString + '&ExBirlesenEh=E';
    }
    if (this.genKisiService.exIhaleKod) {
      if (queryString.length === 1)
        queryString =
          queryString + 'ExIhaleKod=' + this.genKisiService.exIhaleKod;
      else if (queryString.length > 1)
        queryString =
          queryString + '&ExIhaleKod=' + this.genKisiService.exIhaleKod;
    }
    if (this.genKisiService.teklifKod) {
      if (queryString.length === 1)
        queryString =
          queryString + 'TeklifKod=' + this.genKisiService.teklifKod;
      else if (queryString.length > 1)
        queryString =
          queryString + '&TeklifKod=' + this.genKisiService.teklifKod;
    }
    if(this.genKisiService.customQuery){
       if (queryString?.length === 1)
        queryString =
          queryString + this.genKisiService.customQuery;
      else if (queryString?.length > 1)
        queryString =
          queryString + '&' + this.genKisiService.customQuery;
    }
    let tableName = control.dlistMetadata.baseEntity;
    tableName = tableName + queryString;

//     if (customQuery?.length > 0) {
//    const innerDataSource = this.dataCoreService.getOData(tableName, [
//   'GenKisiAdres',
//   'GenKisiIletisims',
// ]);

// const store = new CustomStore({
//   load: async () => {
//     const data = await innerDataSource.load();
//     const dataWithKey = data.map((item: any, index: number) => ({
//       ...item,
//       Kod: item.Kod ?? index
//     }));

//     return {
//       data: dataWithKey,
//       totalCount: dataWithKey.length 
//     };
//   },
//   key: ["Kod"]
// });

// const dataSource = new DataSource({ store, key: 'Kod' });
// return dataSource;
//     } else {
      const dataSource = this.dataCoreService.getOData(tableName, [
        'GenKisiAdres',
        'GenKisiIletisims',
      ]);
      const filterArr = [];
      if (filterArray?.length > 0) {
        filterArr.push(filterArray);
      }
      if (filterArr.length > 0) {
        dataSource.filter(filterArr);
      }
      dataSource.select([]);
      return dataSource;
    
  }
}
